[].slice.call(document.querySelectorAll('.has_subnav')).forEach(subnav => {
    subnav.addEventListener('click', () => {
        subnav.classList.toggle('active')
    })
    document.addEventListener('click', (event) => {
        var isClickedInside = subnav.contains(event.target);
        if (!isClickedInside && subnav.classList.contains('active')) {
            subnav.classList.remove('active')
        }
    })

    document.addEventListener('touchstart', (event) => {
        var isClickedInside = subnav.contains(event.target);
        if (!isClickedInside && subnav.classList.contains('active')) {
            subnav.classList.remove('active')
        }
    })

    if (document.getElementById('wpadminbar')) {
        subnav.classList.add('showsWpNav')
    } else {
        subnav.classList.remove('showsWpNav')
    }
})

document.querySelector('.nav-primary.mobile').addEventListener('click', () => {
    document.querySelector('.mobile_menu_slide').classList.add('visible')
    document.querySelector('html').style.overflow = 'hidden'
})
document.querySelector('.mobile_nav_close').addEventListener('click', () => {
    document.querySelector('.mobile_menu_slide').classList.remove('visible')
    document.querySelector('html').style.overflow = '';
    [].slice.call(document.querySelectorAll('.product ul')).forEach(item => {
        if (item.classList.contains('active')) {
            item.classList.remove('active')
        }
    });
    [].slice.call(document.querySelectorAll('.submenu-modal')).forEach(item => {
        if (item.classList.contains('active')) {
            item.classList.remove('active')
        }
    });
})

document.addEventListener('click', (event) => {
    var langDropdown = document.querySelector('.language-nav .lang_btn');
    var isClickInsideLang = langDropdown.contains(event.target);
    if (!isClickInsideLang && document.querySelector('.language-nav').classList.contains('active')) {
        document.querySelector('.language-nav').classList.remove('active')
      }
})

document.addEventListener('scroll', (event) => {
    document.querySelector('.language-nav').classList.remove('active')
})

document.addEventListener('touchstart', (event) => {
    var langDropdown = document.querySelector('.language-nav .lang_btn');
    var isClickInsideLang = langDropdown.contains(event.target);
    if (!isClickInsideLang && document.querySelector('.language-nav').classList.contains('active')) {
        document.querySelector('.language-nav').classList.remove('active')
      }
})

document.querySelector('.language-nav .lang_btn').addEventListener('click', () => {
    document.querySelector('.language-nav').classList.toggle('active')
})

document.querySelector('.language-nav .english_language').addEventListener('click', () => {
    document.querySelector('.english_language').classList.add('active')
    document.querySelector('.french_language').classList.remove('active')
})

document.querySelector('.language-nav .french_language').addEventListener('click', () => {
    document.querySelector('.english_language').classList.remove('active')
    document.querySelector('.french_language').classList.add('active')
})


document.querySelector('.nav-primary.desktop .nav-search').addEventListener('click', () => {
    document.querySelector('.global_search-modal').classList.add('visible')
    document.querySelector('html').style.overflow = 'hidden'
    $('#search-form__field').val('');
});

document.querySelector('.js-mobile-search').addEventListener('click', () => {
    document.querySelector('.global_search-modal').classList.add('visible')
    document.querySelector('html').style.overflow = 'hidden'
});

document.querySelector('.global_search-modal .close_modal-button').addEventListener('click', () => {
    document.querySelector('.global_search-modal').classList.remove('visible');
    document.querySelector('html').style.overflow = '';
});

[].slice.call(document.querySelectorAll('.product')).forEach(item => {
    item.addEventListener('click', () => {
        item.querySelector('.submenu-modal').classList.toggle('active')
    })
});
